import { useGate } from 'statsig-react';

export function useIsBFCM() {
  return useGate('bfcm_2024').value;
}
